module.exports = __webpack_public_path__ + "img/logo-googleads.e9272e5f.svg";